<script setup lang="ts">
import type { PopoverTriggerProps } from "reka-ui";
import { useCloseAnimation } from "ls/composables/useCloseAnimation";
import { injectPopoverRootContext, PopoverTrigger, useForwardExpose, useForwardProps } from "reka-ui";

defineOptions({
  inheritAttrs: false,
});

const props = defineProps<PopoverTriggerProps>();
const forwarded = useForwardProps(props);

const { forwardRef } = useForwardExpose();

const { open } = injectPopoverRootContext();
const { AnimationPlaceholder } = useCloseAnimation(open);
</script>

<template>
  <AnimationPlaceholder />
  <PopoverTrigger
    :ref="forwardRef"
    v-bind="{ ...forwarded, ...$attrs }"
  >
    <slot />
  </PopoverTrigger>
</template>
